import { AnimatePresence, motion, useReducedMotion } from 'motion/react';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';

import {
  OptionItemSpriteLargeImageContainerStyles,
  OptionItemSpriteLargeListStyles,
  OptionItemSpriteLargeStyles,
} from './OptionItemSpriteLarge.styles';

export const OptionItemSpriteLargeList: React.FC<{
  children?: NonNullable<React.ReactNode>;
  className?: string;
}> = ({ children, className }) => {
  return (
    <OptionItemSpriteLargeListStyles className={className}>
      {children}
    </OptionItemSpriteLargeListStyles>
  );
};

export const OptionItemSpriteLarge: React.FC<{
  spriteSrc: string;
  alt: string;
  title: string;
  isSelected: boolean;
  onClick: () => void;
  TEST_ID?: string;
  theme?: 'violet';
  show: boolean;
  animate?: boolean;
  disableGrayscale?: boolean;
}> = ({
  alt,
  spriteSrc,
  title,
  isSelected,
  onClick,
  TEST_ID,
  theme,
  show,
  animate,
  disableGrayscale = false,
}) => {
  const shouldReduceMotion = useReducedMotion();
  const canAnimate = animate && !shouldReduceMotion;

  if (canAnimate) {
    return (
      <AnimatePresence>
        {show && (
          <motion.div
            variants={{
              hidden: { opacity: 0, x: '100%' },
              visible: { opacity: 1, x: 0, scale: isSelected ? 1.02 : 0.98 },
            }}
            initial="hidden"
            animate="visible"
            exit="hidden"
          >
            <OptionItemSpriteLargeStyles
              isSelected={isSelected}
              onClick={onClick}
              data-testid={TEST_ID}
              theme={theme}
              disableGrayscale={disableGrayscale}
            >
              <UiTypography
                className="option-item-sprite-large-title"
                variant="label-large"
              >
                {title}
              </UiTypography>
              <OptionItemSpriteLargeImageContainerStyles
                isSelected={isSelected}
                disableGrayscale={disableGrayscale}
              >
                <img src={spriteSrc} alt={alt} />
              </OptionItemSpriteLargeImageContainerStyles>
            </OptionItemSpriteLargeStyles>
          </motion.div>
        )}
      </AnimatePresence>
    );
  }

  return (
    <OptionItemSpriteLargeStyles
      isSelected={isSelected}
      onClick={onClick}
      data-testid={TEST_ID}
      theme={theme}
      disableGrayscale={disableGrayscale}
    >
      <UiTypography
        className="option-item-sprite-large-title"
        variant="label-large"
      >
        {title}
      </UiTypography>
      <OptionItemSpriteLargeImageContainerStyles
        isSelected={isSelected}
        disableGrayscale={disableGrayscale}
      >
        <img src={spriteSrc} alt={alt} />
      </OptionItemSpriteLargeImageContainerStyles>
    </OptionItemSpriteLargeStyles>
  );
};
